import React from 'react';
import {
    AddBoxOutlined, ArrowBack, ArrowDownward, ArrowForward, ArrowUpward, ContentCopyOutlined,
    ContentPasteOutlined, DeleteOutline, EditOutlined, LibraryAddOutlined,
} from '@mui/icons-material';

const IS_MAC = typeof navigator !== 'undefined' && /mac/i.test(navigator.platform);
const COMMAND = IS_MAC ? '⌘' : 'Ctrl+';
const ICON = { fontSize: 'small' };

// A menu label with its keyboard shortcut on the right.
const label = (text, shortcut) => (
    <span className="map-context-menu-label">
        <span>{text}</span>
        {shortcut && <kbd>{shortcut}</kbd>}
    </span>
);

const INSERT_ITEMS = [
    { key: 'insert:above', label: 'Above', icon: <ArrowUpward {...ICON} /> },
    { key: 'insert:below', label: 'Below', icon: <ArrowDownward {...ICON} /> },
    { key: 'insert:left', label: 'Left', icon: <ArrowBack {...ICON} /> },
    { key: 'insert:right', label: 'Right', icon: <ArrowForward {...ICON} /> },
];

// Items for a right-click on a node, an edge or the empty canvas (D-037).
export const menuItemsFor = (kind, { canPaste }) => {
    if (kind === 'edge') {
        return [{ key: 'delete', label: label('Delete', 'Del'), icon: <DeleteOutline {...ICON} />, danger: true }];
    }
    if (kind === 'pane') {
        return [
            { key: 'paste-here', label: label('Paste here', `${COMMAND}V`), icon: <ContentPasteOutlined {...ICON} />, disabled: !canPaste },
            { key: 'insert-here', label: label('Insert node here'), icon: <AddBoxOutlined {...ICON} /> },
        ];
    }
    return [
        { key: 'copy', label: label('Copy', `${COMMAND}C`), icon: <ContentCopyOutlined {...ICON} /> },
        { key: 'paste', label: label('Paste', `${COMMAND}V`), icon: <ContentPasteOutlined {...ICON} />, disabled: !canPaste },
        { key: 'duplicate', label: label('Duplicate', `${COMMAND}D`), icon: <LibraryAddOutlined {...ICON} /> },
        { type: 'divider' },
        { key: 'insert', label: 'Insert node', icon: <AddBoxOutlined {...ICON} />, children: INSERT_ITEMS },
        { key: 'edit', label: label('Edit…'), icon: <EditOutlined {...ICON} /> },
        { type: 'divider' },
        { key: 'delete', label: label('Delete', 'Del'), icon: <DeleteOutline {...ICON} />, danger: true },
    ];
};
